import dayjs from 'dayjs';
import { useMemo } from 'react';
import { ProductOrderInList } from '../../../api/hooks/products/useProductOrders';
import { ItemCard } from '../../../components/atoms/ItemCard';
import { ItemCardField } from '../../../components/atoms/ItemCardField';
import { CURRENCY } from '../../../interfaces/enumerables';
import { PATHS } from '../../../navigation/data';

interface Props {
  index: number;
  data: ProductOrderInList;
}

export const ProductOrderItemCard = ({ index, data }: Props) => {
  const dateStr = data.createdAt ? dayjs(data.createdAt).format('YYYY-MM-DD') : '-';
  const currencySymbol = useMemo(() => CURRENCY[data.invoice?.currency || 'EUR'], [data.invoice?.currency]);

  return (
    <div className="width-100 itemOfList positionRelative">
      <ItemCard index={index} routerLink={`${PATHS.SALES}/view/${data.invoiceId}`}>
        <div className="flex-space-between-center-row-wrap width-100">
          <ItemCardField classes="margin-r-24" width="width-180px" value={dateStr} />
          <ItemCardField classes="margin-r-24" width="width-80px" value={`${data.price} ${currencySymbol}`} />
          <ItemCardField classes="margin-r-24" width="width-80px" value={`x ${data.quantity}`} />
          <ItemCardField classes="margin-r-0" width="width-120px" value={`${data.finalCost} ${currencySymbol}`} />
        </div>
      </ItemCard>
    </div>
  );
};
